<template>
  <div class="event-creation">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("scheduler.event.creation.title") }}</span>
      </v-card-title>
      <v-card-text v-if="!loading">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="data.title"
            prepend-icon="short_text"
            :rules="$rules('event.title')"
            :label="$t('scheduler.event.fields.title')"
            required
          ></v-text-field>
          <v-checkbox
            v-model="data.allDay"
            :label="$t('scheduler.event.fields.all-day')"
          />

          <v-datetime-picker
            v-if="dialog"
            v-model="data.start"
            :label="$t('scheduler.event.fields.start')"
            prepend-icon="schedule"
          ></v-datetime-picker>
          <v-datetime-picker
            v-if="dialog"
            v-model="data.end"
            :label="$t('scheduler.event.fields.end')"
            prepend-icon="schedule"
          ></v-datetime-picker>

          <v-text-field
            v-model="data.url"
            prepend-icon="link"
            :rules="$rules('app.url')"
            :label="$t('scheduler.event.fields.link')"
          ></v-text-field>
          <v-select
            v-model="data.rendering"
            :items="availableRenderings"
            prepend-icon="event"
            item-text="text"
            item-value="value"
            :rules="$rules('scheduler.event.rendering')"
            :label="$t('scheduler.event.fields.rendering')"
          ></v-select>
          <v-text-field
            v-model="data.image"
            prepend-icon="link"
            :rules="$rules('app.image')"
            :label="$t('scheduler.event.fields.image')"
          ></v-text-field>
          <v-text-field
            v-model="data.abstract"
            prepend-icon="short_text"
            :rules="$rules('scheduler.event.shortDescription')"
            :label="$t('scheduler.event.fields.abstract')"
          ></v-text-field>
          <v-textarea
            v-model="data.description"
            prepend-icon="notes"
            auto-grow
            :rules="$rules('scheduler.event.longDescription')"
            :label="$t('scheduler.event.fields.description')"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined @click="back">
          {{ $t("app.buttons.back") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :readonly="!valid"
          :loading="submitting"
          dark
          color="mdred lighten-1"
          @click="submit"
        >
          {{ $t("app.buttons.submit") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import adaptersOut from "@/services/data-adapter/outgoing/scheduler";

export default {
  props: {
    defaultData: {
      type: Object,
      required: true
    },
    dialog: Boolean
  },
  data: () => ({
    submitting: false,
    options: {
      tabDateTitle: "Date",
      tabTimeTitle: "Time",
      icon: "event",
      iconTime: "av_timer",
      closeOnDateClick: false,
      useSeconds: false,
      clearable: true
    },

    availableRenderings: ["", "background"],
    valid: true,
    loading: true,
    data: {
      title: null,
      allDay: false,
      start: null,
      end: null,
      url: null,
      rendering: null,
      abstract: null,
      description: null,
      image: null
    }
  }),

  watch: {
    defaultData: {
      handler: function() {
        this.updateDates();
      },
      deep: true
    }
  },

  mounted: function() {
    this.$nextTick(async function() {
      this.updateDates();
      this.loading = false;
    });
  },

  methods: {
    updateDates() {
      const copy = Object.create(this.defaultData);
      this.data.start = copy.start;
      this.data.end = copy.end;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        adaptersOut.event(this.data).then(res => {
          const event = res;
          this.$http
            .post(
              "/events",
              { event },
              { withCredentials: true, credentials: "include", mode: "cors" }
            )
            .then(request => this.submitSuccessful(request.data))
            .catch(error => this.submitFailed(error));
        });
      }
    },

    submitSuccessful(req) {
      this.submitting = false;
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "success",
          // We use a custom message, not the default one
          message: this.$t("scheduler.event.creation.success")
        },
        { root: true }
      );
      this.$router.push("/classes/" + req.data.id);
    },

    submitFailed(error) {
      this.submitting = false;
      if (process.env.NODE_ENV !== "production") {
        console.log(error.response);
      }
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "error",
          message: this.$t("app.actions.failed.creation")
        },
        { root: true }
      );
    },

    back() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.v-picker__body {
  margin: initial;
}
</style>
